module.exports = __webpack_public_path__ + "static/img/ptzs2.195f39d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ptzs2.png
// module id = IT2F
// module chunks = 0